module.exports = __webpack_public_path__ + "static/img/icon-upload-add.9ced6621.svg";